import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postPlantLevelConfigSlice = createApi(`PostPlantLevelConfigSlice`,"POST");

const PostPlantLevelConfigSlice = createSlice({
  name: 'PostPlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postPlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postPlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostPlantLevelConfigSlice.reducer;